// home video slider
$(document).ready(function(){
  $('#shopify-section-custom_content_w73tkL .custom-content').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  loop:true,
  autoplay: true,
  autoplaySpeed: 4000,
  responsive: [
      {
      breakpoint: 1024,
      settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true
      }
      },
      {
      breakpoint: 600,
      settings: {
          slidesToShow: 2,
          slidesToScroll: 1
      }
      },
      {
      breakpoint: 480,
      settings: {
          slidesToShow: 1,
          slidesToScroll: 1
      }
      }

  ]
  });
  
});

//inner page slider
$(document).ready(function(){
  $('.in_pg_gallery_slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  loop:true,
  autoplay: true,
  autoplaySpeed: 4000,
  responsive: [
      {
      breakpoint: 1024,
      settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true
      }
      },
      {
      breakpoint: 600,
      settings: {
          slidesToShow: 2,
          slidesToScroll: 1
      }
      },
      {
      breakpoint: 480,
      settings: {
          slidesToShow: 1,
          slidesToScroll: 1
      }
      }

  ]
  });
  
});


